import type { SerializedEntity } from '#entities/lib/entities'
import { getEditionsWorks } from '#entities/lib/entities'
import type { Component } from 'svelte'

export async function getEntityLayoutComponentByType (entity: SerializedEntity): Promise<{ component: Component, props: object }> {
  const { type } = entity

  let component
  if (type === 'edition') {
    const [ { default: EditionLayout }, works ] = await Promise.all([
      import('#entities/components/layouts/edition.svelte'),
      getEditionsWorks([ entity ]),
    ])
    const props = { entity, works }
    return { component: EditionLayout, props }
  } else if (type === 'human') {
    ({ default: component } = await import('#entities/components/layouts/author.svelte'))
  } else if (type === 'serie') {
    ({ default: component } = await import('#entities/components/layouts/serie.svelte'))
  } else if (type === 'work') {
    ({ default: component } = await import('#entities/components/layouts/work.svelte'))
  } else if (type === 'publisher') {
    ({ default: component } = await import('#entities/components/layouts/publisher.svelte'))
  } else if (type === 'collection') {
    ({ default: component } = await import('#entities/components/layouts/collection.svelte'))
  } else if (type === 'article') {
    ({ default: component } = await import('#entities/components/layouts/article.svelte'))
  } else {
    ({ default: component } = await import('#entities/components/layouts/claim_layout.svelte'))
    const property = defaultClaimPropertyByType[type] || 'wdt:P921'
    return { component, props: { entity, property } }
  }
  return { component, props: { entity } }
}

const defaultClaimPropertyByType = {
  movement: 'wdt:P135',
  genre: 'wdt:P136',
  subject: 'wdt:P921',
}
